<template>
  <div class="footer">
    <!-- 有总数 -->
    <el-pagination
      background
      layout="total, prev, pager, next, sizes"
      :total="total"
      :page-sizes="pageSizes"
      @size-change="changeSize"
      @current-change="tochangePage"
      v-if="showTotal"
    />
    <!-- 无总数 -->
    <div class="el-pagination is-background" v-else>
      <el-button
        icon="el-icon-arrow-left"
        class="btn-prev"
        :disabled="queryForm.current <= 1"
        @click="toPrev"
      />
      <ul class="el-pager">
        <li class="is-active number">{{ queryForm.current }}</li>
      </ul>
      <el-button
        icon="el-icon-arrow-right"
        class="btn-next"
        :disabled="total < queryForm.size"
        @click="toNext"
      />
      <el-select v-model="queryForm.size" @change="changeSize">
        <el-option
          v-for="item in pageSizes"
          :label="item + '条/页'"
          :key="item"
          :value="item"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 无总数时，该数值为当前页总数，有总数时，为总数据条数
    total: {
      type: Number,
      default: 0
    },
    // 是否显示总数
    showTotal: {
      type: Boolean,
      default: true
    },
    current: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      pageSizes: [10, 20, 30, 40, 50, 100],
      queryForm: {
        current: this.current,
        size: this.size
      }
    }
  },
  methods: {
    changeSize (val) {
      this.$emit('change', { size: val, current: 1 })
    },
    toPrev () {
      this.$emit('change', { size: this.queryForm.size, current: this.queryForm.current - 1 })
    },
    toNext () {
      this.$emit('change', { size: this.queryForm.size, current: this.queryForm.current + 1 })
    },
    tochangePage (val) {
      this.$emit('change', { size: this.queryForm.size, current: val })
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>
